<template>
  <mw-dialog ref="dialog" size="mini_mini" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <el-form :model="form" label-width="100px" :rules="formRules" ref="secrecordForm" style="padding-top:20px;">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$lang('代录领导')+'：'">
            <template><span v-html="params.ownerName"></span></template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$lang('办理意见')+'：'" prop="comment">
            <el-input type="textarea" v-model="form.comment"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </mw-dialog>
</template>
<script>

  export default {
    props: {
      params: {
        type: Object
      }
    },
    data() {
      let me=this;
      return {
        title:$lang('意见代录'),
        form:{
          comment:''
        },
        formRules:{
           comment:[{ required: true, message: $lang("请输入办理意见"), trigger: "blur" }]
        },
        footerButton: [
          {
            label: $lang("关闭"),
            type: "default",
            func:me.close
          },
          {
            label: $lang("确定"),
            func:me.submit
          }
        ]
      }
    },
    mounted() {
      var me = this;
      setTimeout(()=>{
        me.show();
      },200)
      me.form.comment='';
    },
    methods: {
      setBtnLoading(loading,idx){
        this.footerButton[idx].loading=loading;
      },
      btnDebounce:_.debounce(function(callback){
        let me=this;
        if(callback){
          callback();
        }
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      submit(){
        let me=this;
        this.mwRef("secrecordForm").validate(valid => {
        if(valid) {
          me.btnDebounce(function(){
            me.setBtnLoading(true,1);
            var p = {};
            p.comment = me.form.comment;
            me.formActionComplete(p);
            me.setBtnLoading(false,1);
          });
        }else{
          //me.mwMsg("信息未填写完整");
          return;
        }
        });
      },
      beforeClose(done){
        var me=this;
        //me.mwConfirm('确认退出意见代录窗口？').then(_ => {
          if(me.params.secondfunc){
            me.params.secondfunc()
          }
          me.resetForm();
          done();
        // }).catch(_ => {
        // });
      },
      resetForm(){
        var me=this;
        me.form.comment='';
      },
      formActionComplete(p){
        let me=this;
        if(me.params.func){
          me.params.func(p)
        }
        me.close();
        this.resetForm();
      },
      show(){
        this.mwRef('dialog').show();
      },
      close(){
        this.resetForm();
        this.mwRef('dialog').hide();
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/common/components/public-dialog/secrecord.vue